import localization from "../../statics/localization";

const copy = {
  tr: {
    eyebrow: "İZLEMEYE DEĞER BİR DÜNYA",
    title: "Her hikâye,",
    highlight: "yeni bir dünya.",
    description:
      "Seni içine çeken filmler, bir bölüm daha dedirten diziler ve hayatın içinden canlı yayınlar.",
    welcome: "Giriş yap",
    username: "Kullanıcı adı veya e-posta",
    placeholder: "Kullanıcı adını gir",
    showPassword: "Şifreyi göster",
    hidePassword: "Şifreyi gizle",
    pending: "Giriş yapılıyor…",
    session: "Oturumun hazırlanıyor…"
  },
  eng: {
    eyebrow: "A WORLD WORTH WATCHING",
    title: "Every story,",
    highlight: "a new world.",
    description:
      "Films that draw you in. Series that keep you watching. Live moments that bring us together.",
    welcome: "Sign in",
    username: "Username or email",
    placeholder: "Enter your username",
    showPassword: "Show password",
    hidePassword: "Hide password",
    pending: "Signing in…",
    session: "Preparing your session…"
  },
  arb: {
    eyebrow: "عالم يستحق المشاهدة",
    title: "كل قصة،",
    highlight: "عالم جديد.",
    description:
      "أفلام تأخذك إلى عالمها، ومسلسلات تتابعها بشغف، ولحظات مباشرة تجمعنا.",
    welcome: "تسجيل الدخول",
    username: "اسم المستخدم أو البريد الإلكتروني",
    placeholder: "أدخل اسم المستخدم",
    showPassword: "إظهار كلمة المرور",
    hidePassword: "إخفاء كلمة المرور",
    pending: "جارٍ تسجيل الدخول…",
    session: "جارٍ إعداد جلستك…"
  }
};

export const getLoginCopy = () => copy[localization.getLanguage()] || copy.eng;
